<template>
  <header class="modern-header">
    <div class="header-container">
      <div class="brand">TJ</div>

      <!-- 桌面端导航 -->
      <nav aria-label="主导航" class="desktop-nav">
        <ul class="nav-links">
          <li><router-link to="/">首页</router-link></li>
          <li><a href="#">热门模版</a></li>
          <li><router-link to="/vip">会员定价</router-link></li>
          <li><a href="#">开发者API</a></li>
        </ul>
      </nav>

      <!-- 移动端菜单按钮 -->
      <div class="mobile-menu-btn" @click="showMobileMenu = !showMobileMenu">
        <svg v-if="!showMobileMenu" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <line x1="3" y1="12" x2="21" y2="12"></line>
          <line x1="3" y1="6" x2="21" y2="6"></line>
          <line x1="3" y1="18" x2="21" y2="18"></line>
        </svg>
        <svg v-else width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </div>

      <!-- 未登录 → 显示登录注册 -->
      <div v-if="!isLogin" class="auth-buttons">
        <router-link to="/login" class="login-link">登录</router-link>
        <button class="register-btn" @click="toRegister">立即注册</button>
      </div>

      <!-- 已登录 → 左侧显示次数 + 右侧用户信息 -->
      <div v-else class="user-wrapper">
        <!-- 🔥 今日次数（左侧，带文字提示） -->
        <div class="usage-left">
          <span class="usage-label">今日可用：</span>
          <span class="usage-num">{{ getDailyUsage }}/{{ getDailyLimit }}</span>
          <div class="usage-progress-small">
            <div class="progress-bar-small" :style="{ width: (getDailyUsage / getDailyLimit) * 100 + '%' }"></div>
          </div>
        </div>

        <!-- 用户信息（右侧） -->
        <div class="user-dropdown">
          <div class="user-trigger">
            <span class="avatar">{{ userInfo?.username ? userInfo.username.charAt(0) : "U" }}</span>
            <span class="vip-tag" :class="vipLevelClass">{{ vipLevelText }}</span>
          </div>
          <div class="dropdown-menu">
            <div class="dropdown-item" @click="toUserCenter">个人中心</div>
            <div class="dropdown-item logout-item" @click="logout">退出登录</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 移动端导航菜单 -->
    <div class="mobile-nav" :class="{ open: showMobileMenu }">
      <router-link to="/" @click="showMobileMenu = false">首页</router-link>
      <a href="#">热门模版</a>
      <router-link to="/vip" @click="showMobileMenu = false">会员定价</router-link>
      <a href="#">开发者API</a>

      <!-- 🔥 移动端保留次数显示 -->
      <div v-if="isLogin" class="usage-mobile">
        <span>今日可用：{{ getDailyUsage }}/{{ getDailyLimit }}</span>
        <div class="progress-mobile">
          <div class="bar-mobile" :style="{ width: (getDailyUsage / getDailyLimit) * 100 + '%' }"></div>
        </div>
      </div>

      <div v-if="!isLogin" class="mobile-auth">
        <router-link to="/login" @click="showMobileMenu = false">登录</router-link>
        <router-link to="/register" @click="showMobileMenu = false">注册</router-link>
      </div>
    </div>
  </header>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Header',
  data() {
    return {
      showMobileMenu: false
    }
  },
  computed: {
    ...mapGetters(['getDailyUsage', 'getDailyLimit']),

    isLogin() {
      return this.$store.getters.getToken && this.$store.getters.getToken.length > 0
    },
    userInfo() {
      return this.$store.getters.getUserInfo || {}
    },
    vipLevel() {
      return this.userInfo.vipLevel || 'VIP0'
    },
    vipLevelText() {
      if (this.vipLevel === 'VIP0') return '免费'
      if (this.vipLevel === 'VIP1') return 'VIP1'
      if (this.vipLevel === 'VIP2') return 'VIP2'
      return '免费'
    },
    vipLevelClass() {
      if (this.vipLevel === 'VIP0') return 'vip-free'
      if (this.vipLevel === 'VIP1') return 'vip1'
      if (this.vipLevel === 'VIP2') return 'vip2'
      return 'vip-free'
    }
  },
  methods: {
    toRegister() {
      this.$router.push('/login')
    },
    toUserCenter() {
      this.$router.push('/user')
    },
    logout() {
      this.$store.commit('CLEAR_USER_INFO')
      this.$router.replace({ path: '/login' })
    }
  }
}
</script>

<style scoped>
.modern-header {
  background-color: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(10px);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  position: sticky;
  top: 0;
  z-index: 50;
  border-bottom: 1px solid #eef2f6;
  width: 100%;
  box-sizing: border-box;
}

.header-container {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0.875rem 2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: nowrap;
  gap: 1rem;
  width: 100%;
  box-sizing: border-box;
}

.brand {
  color: #ffffff;
  width: 42px;
  height: 42px;
  background-color: rgb(79 70 229);
  border-radius: 10px;
  font-size: 1.8rem;
  font-weight: 700;
  display: flex;
  justify-content: center;
  align-items: center;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  flex-shrink: 0;
}

/* 桌面导航 */
.desktop-nav {
  display: block;
  flex: 1;
  margin: 0 2rem;
}
.nav-links {
  display: flex;
  align-items: center;
  gap: 2rem;
  list-style: none;
  padding: 0;
  margin: 0;
  justify-content: center;
}
.nav-links a, .nav-links router-link {
  text-decoration: none;
  font-weight: 500;
  font-size: 1rem;
  color: #334155;
  transition: all 0.2s ease;
  padding: 0.25rem 0;
  position: relative;
  white-space: nowrap;
}
.nav-links a::after, .nav-links router-link::after {
  content: '';
  position: absolute;
  bottom: -4px;
  left: 0;
  width: 0;
  height: 2px;
  background: #4f46e5;
  border-radius: 4px;
  transition: width 0.2s ease;
}
.nav-links a:hover, .nav-links router-link:hover {
  color: #4f46e5;
}
.nav-links a:hover::after, .nav-links router-link:hover::after {
  width: 100%;
}

/* 移动端菜单按钮 */
.mobile-menu-btn {
  display: none;
  cursor: pointer;
  color: #334155;
  flex-shrink: 0;
}

/* 登录栏 */
.auth-buttons {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-shrink: 0;
}
.login-link {
  font-size: 0.95rem;
  font-weight: 500;
  color: #1e293b;
  text-decoration: none;
  padding: 0.5rem 0.75rem;
  border-radius: 40px;
  transition: all 0.2s ease;
}
.login-link:hover {
  background-color: #4f46e5;
  color: #ffffff;
}
.register-btn {
  background-color: rgb(79 70 229);
  color: white;
  border: none;
  font-weight: 600;
  font-size: 0.9rem;
  padding: 0.5rem 1.2rem;
  border-radius: 40px;
  cursor: pointer;
  transition: all 0.2s ease;
}
.register-btn:hover {
  background: #1e293b;
  transform: translateY(-1px);
}

/* ===================== 已登录布局：左侧次数 + 右侧用户 ===================== */
.user-wrapper {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-shrink: 0;
}

/* 🔥 左侧次数模块（带文字提示） */
.usage-left {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  background: #f8faff;
  border: 1px solid #e0e9ff;
  border-radius: 12px;
  white-space: nowrap;
}
.usage-label {
  font-size: 12px;
  color: #64748b;
  font-weight: 500;
}
.usage-num {
  font-size: 13px;
  font-weight: 600;
  color: #334155;
}
.usage-progress-small {
  width: 40px;
  height: 4px;
  background: #eaefff;
  border-radius: 99px;
  overflow: hidden;
}
.progress-bar-small {
  height: 100%;
  background: linear-gradient(90deg, #6366f1 0%, #a855f7 100%);
  border-radius: 99px;
  transition: width 0.3s ease;
}

/* ===================== 用户下拉菜单 + VIP 标签 ===================== */
.user-dropdown {
  position: relative;
  display: inline-block;
  flex-shrink: 0;
}
.user-trigger {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 0.35rem 0.8rem;
  background: #f5f7ff;
  border-radius: 40px;
  cursor: pointer;
  white-space: nowrap;
}
.avatar {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: #4f46e5;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 13px;
  flex-shrink: 0;
}
.vip-tag {
  font-size: 11px;
  padding: 1px 5px;
  border-radius: 8px;
  font-weight: 600;
  white-space: nowrap;
  min-width: 32px;
  text-align: center;
}
.vip-free {
  background: #e2e8f0;
  color: #64748b;
}
.vip1 {
  background: #fef3c7;
  color: #d97706;
}
.vip2 {
  background: #fce7f3;
  color: #db2777;
}

.dropdown-menu {
  position: absolute;
  top: 120%;
  right: 0;
  width: 140px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  opacity: 0;
  visibility: hidden;
  transform: translateY(10px);
  transition: all 0.2s ease;
  z-index: 99;
}
.user-dropdown:hover .dropdown-menu {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}
.dropdown-item {
  padding: 0.6rem 1rem;
  font-size: 0.9rem;
  color: #333;
  cursor: pointer;
  transition: background 0.2s;
}
.dropdown-item:hover {
  background: #f5f7ff;
  color: #4f46e5;
}
.logout-item {
  color: #f43f5e;
}
.logout-item:hover {
  background: #fef2f2;
}

/* ===================== 移动端导航 ===================== */
.mobile-nav {
  display: flex;
  flex-direction: column;
  background: white;
  padding: 0 2rem;
  gap: 1rem;
  border-top: 1px solid #e2e8f0;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease;
}
.mobile-nav.open {
  max-height: 500px;
  padding: 1rem 2rem;
}
.mobile-nav a, .mobile-nav router-link {
  text-decoration: none;
  color: #334155;
  font-weight: 500;
  padding: 0.5rem 0;
}
.mobile-auth {
  display: flex;
  gap: 1rem;
  padding-top: 0.5rem;
  border-top: 1px dashed #e2e8f0;
}

/* 🔥 移动端次数（保留显示） */
.usage-mobile {
  margin-top: 4px;
  padding: 8px 10px;
  background: #f8faff;
  border-radius: 8px;
  font-size: 13px;
  color: #4e5969;
}
.progress-mobile {
  height: 4px;
  background: #eaefff;
  border-radius: 99px;
  margin-top: 4px;
  overflow: hidden;
}
.bar-mobile {
  height: 100%;
  background: linear-gradient(90deg, #6366f1 0%, #a855f7 100%);
  border-radius: 99px;
}

/* ===================== 响应式适配 ===================== */
@media (max-width: 992px) {
  .desktop-nav {
    display: none;
  }
  .mobile-menu-btn {
    display: block;
  }
  .auth-buttons {
    display: none;
  }
  .header-container {
    padding: 0.7rem 1rem;
  }
}

@media (max-width: 820px) {
  .brand {
    width: 36px;
    height: 36px;
    font-size: 1.5rem;
  }
  .user-trigger {
    padding: 0.3rem 0.6rem;
    gap: 4px;
  }
  .avatar {
    width: 24px;
    height: 24px;
    font-size: 12px;
  }
  .vip-tag {
    font-size: 10px;
    padding: 1px 4px;
    min-width: 28px;
  }
  /* 移动端缩小左侧次数模块 */
  .usage-left {
    padding: 4px 8px;
    gap: 4px;
  }
  .usage-label {
    font-size: 11px;
  }
  .usage-num {
    font-size: 12px;
  }
  .usage-progress-small {
    width: 35px;
  }
}

@media (max-width: 480px) {
  .vip-tag {
    font-size: 9px;
    padding: 0 3px;
    min-width: 24px;
  }
  .user-trigger {
    padding: 0.25rem 0.5rem;
  }
  /* 超小屏进一步适配 */
  .usage-left {
    padding: 3px 6px;
  }
  .usage-label {
    font-size: 10px;
  }
  .usage-num {
    font-size: 11px;
  }
  .usage-progress-small {
    width: 30px;
  }
}
</style>